export default "__VITE_ASSET__Dksqqq2n__"